import { Cancel } from "@mui/icons-material";
import { Card, CircularProgress } from "@mui/material";
import ApnaSelect2 from "components/ApnaSelect";
import ImagePicker from "components/ApnaUploader";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState } from "react";
import AstrieskIcon from "components/AstrieskIcon";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
import { updateCategory } from "redux/festures/categorySlice";
import { handleAlert } from "redux/festures/alertSlice";
import { getGlobalCategory } from "redux/festures/categorySlice";
import { creatCategoryData } from "redux/festures/categorySlice";
import { getCategory } from "redux/festures/categorySlice";

const SubcategoryUpdate = ({ viewData, isUpdates, setIsOpenUpdate2, filter, pagess, search }) => {
 
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const dispatch = useDispatch();

  const admin = localStorage.getItem("admin_id");

  const {
    Loading,
    category,
    allCategory,
    subCategory,
    IsLoading,
    isPages,
    subCategoryData,
    createUpdateLoading,
  } = useSelector((state) => state.isCategory);

  useEffect(() => {
    dispatch(getCategory(`/getAllNullPcategory/${admin}?disable=false`));
  }, []);

  const [profile, setProfile] = useState({
    categoryName: "",
    uploadPic: "",
    bannerImage: "",
    bannerVideo: "",
    cityId: [],
    categoryId: "",
    category__Id: "",
    isShow: "",
    serverBannerImage: null,
  });

  const [errors, setErrors] = useState({});

  const scrollToField = (fieldId) => {
    setTimeout(() => {
      const element = document.getElementById(fieldId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        const input = element.querySelector("input, textarea, select") || element;
        if (input && typeof input.focus === "function") {
          input.focus();
        }
      }
    }, 100);
  };

  useEffect(() => {
    setErrors({});
    if (viewData && isUpdates) {
      setProfile({
        categoryName: viewData?.name || "",
        uploadPic: "",
        bannerImage: "",
        bannerVideo: "",
        // cityId:
        //   city && city?.length && viewData?.cityId?.length
        //     ? city?.filter((ele) => viewData?.cityId?.includes(ele?._id))
        //     : [],
        categoryId:
          (typeof viewData?.pCategory === "object" && viewData?.pCategory !== null)
            ? viewData?.pCategory?._id
            : viewData?.pCategory || "",
        category__Id: viewData?._id || "",
        isShow: viewData?.icon || "",
        serverBannerImage: viewData?.banner?.length
          ? viewData?.banner?.filter((ele) => ele?.type === "IMAGE")
          : null,
      });
    } else {
      setProfile({
        categoryName: "",
        uploadPic: "",
        bannerImage: "",
        bannerVideo: "",
        cityId: [],
        categoryId: "",
        category__Id: "",
        isShow: "",
        serverBannerImage: null,
      });
    }
  }, [viewData, isUpdates]);

  const handleSubmitUpdateSubCategory = (e) => {
    e.preventDefault();

    if (!profile?.categoryId) {
      setErrors({ categoryId: "Please select a Parent Category!" });
      dispatch(
        handleAlert({
          isOpen: true,
          type: "error",
          msg: "Validation Error: Please select a Parent Category!",
        })
      );
      scrollToField("field-parentCategory");
      return;
    }

    if (!profile?.categoryName || !profile?.categoryName.trim()) {
      setErrors({ categoryName: "Sub Category Name is required!" });
      dispatch(
        handleAlert({
          isOpen: true,
          type: "error",
          msg: "Validation Error: Sub Category Name is required!",
        })
      );
      scrollToField("field-subCategoryName");
      return;
    }

    setErrors({});

    const parentCatId =
      typeof profile?.categoryId === "object" && profile?.categoryId !== null
        ? profile?.categoryId?._id
        : profile?.categoryId;

    const formData = new FormData();
    formData.append("name", profile.categoryName);
    if (profile?.uploadPic) formData.append("icon", profile.uploadPic);
    if (parentCatId && parentCatId !== "undefined" && parentCatId !== "null") {
      formData.append("pCategory", parentCatId);
    }

    if (profile?.bannerImage && profile?.bannerImage?.length)
      profile?.bannerImage?.map((e) => formData.append("banner", e));

    dispatch(
      isUpdates
        ? updateCategory({
            url: `/updateCategory/${profile?.category__Id}/${admin}`,
            data: formData,
          })
        : creatCategoryData({
            url: `/createCategory/${admin}`,
            reqBody: formData,
          })
    ).then((data) => {
      dispatch(
        handleAlert({
          isOpen: true,
          type: `${data?.payload?.success ? "success" : "error"}`,
          msg: data?.payload?.message,
        })
      );
      if (data?.payload?.success) {
        setProfile({
          categoryName: "",
          uploadPic: "",
          bannerImage: "",
          bannerVideo: "",
          cityId: [],
          categoryId: "",
          category__Id: "",
          isShow: "",
          serverBannerImage: null,
        });
        setErrors({});
        // setFile();
        const encodedSearch = search ? encodeURIComponent(search.trim()) : "";
        dispatch(
          getGlobalCategory(
            `getAllCategoryWithPcategory/${admin}?disable=${
              filter === false ? false : filter || ""
            }&page=${pagess || 1}${encodedSearch ? `&search=${encodedSearch}` : ""}`
          )
        );
        // setIsOpen(false);
        // setIsOpen2(false);
        // setIsOpenUpdate(false);
        setIsOpenUpdate2(false);
      } else if (data?.payload?.message?.toLowerCase().includes("duplicate")) {
        setErrors({ categoryName: data.payload.message });
        scrollToField("field-subCategoryName");
      }
    });
  };

  return (
    <>
      <MDBox
        display="flex"
        alignItems="center"
        lineHeight={1}
        sx={({ palette: { dark, white, info } }) => ({
          border: 0.5,
          borderColor: darkMode ? white.main : dark.main,
          borderRadius: 3,
          p: 2,
          width: "100%",
          //   height: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 2,
        })}
      >
        <Card
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 , 10px",
          }}
        >
          <MDTypography variant="h6" py={0.9}>
            {isUpdates ? " Update Sub Category" : "Create Sub Category"}
          </MDTypography>
        </Card>

        <MDBox
          display="flex"
          alignItems="center"
          lineHeight={1}
          sx={{
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            gap: 5,
            width: "100%",
          }}
          component="form"
          role="form"
          noValidate
          onSubmit={handleSubmitUpdateSubCategory}
        >
          <MDBox
            id="field-parentCategory"
            display="flex"
            alignItems="flex-start"
            flexDirection="column"
            lineHeight={1}
            justifyContent="flex-start"
            gap={1.5}
            width={"75%"}
          >
            <MDTypography variant="h6">
              Select Parent Category <AstrieskIcon />
            </MDTypography>

            <MDBox
              sx={{
                width: "100%",
                ...(errors?.categoryId && {
                  border: "1.5px solid #d32f2f",
                  borderRadius: "8px",
                }),
              }}
            >
              <ApnaSelect2
                disabled={createUpdateLoading}
                data={allCategory}
                origin="Category"
                value={profile?.categoryId}
                name="categoryId"
                onChange={(e) => {
                  if (errors?.categoryId) {
                    setErrors((prev) => {
                      const next = { ...prev };
                      delete next.categoryId;
                      return next;
                    });
                  }
                  setProfile((prev) => ({
                    ...prev,
                    categoryId: e.target.value,
                  }));
                }}
                nameKey="name"
                valueKey="_id"
              />
            </MDBox>
          </MDBox>
          <MDBox
            id="field-subCategoryName"
            display="flex"
            alignItems="flex-start"
            flexDirection="column"
            justifyContent="flex-start"
            lineHeight={1}
            gap={1.5}
            width={"75%"}
          >
            <MDTypography variant="h6">
              Sub Category Name
              <AstrieskIcon />
            </MDTypography>
            <MDInput
              disabled={createUpdateLoading}
              error={Boolean(errors?.categoryName)}
              type="text"
              placeholder="sub category name"
              fullWidth
              pl={3}
              value={profile.categoryName}
              onChange={(e) => {
                if (errors?.categoryName) {
                  setErrors((prev) => {
                    const next = { ...prev };
                    delete next.categoryName;
                    return next;
                  });
                }
                setProfile((prev) => ({
                  ...prev,
                  categoryName: e.target.value,
                }));
              }}
            />
          </MDBox>

          <MDBox
            display="flex"
            alignItems="flex-start"
            flexDirection="column"
            lineHeight={1}
            gap={3}
            width={"75%"}
          >
            <MDTypography variant="h6">
              Sub Category Image{" "}
              <MDTypography variant="body1" component="span" fontSize={11}>
                &nbsp; ( image size - 178 × 178 px )
              </MDTypography>
            </MDTypography>
            <ImagePicker
              disabled={createUpdateLoading}
              name="Image"
              multiple={false}
              targetWidth={178}
              targetHeight={178}
              images={profile?.uploadPic}
              setImages={(e) => {
                setProfile((prev) => ({
                  ...prev,
                  uploadPic: e,
                }));
              }}
              //
            />
            {profile?.uploadPic === "" && profile?.isShow && (
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <span
                  style={{
                    display: "inline-block",
                    width: "50px",
                    height: "50px",
                    margin: "0 0.5rem",
                  }}
                >
                  <img
                    className="Image"
                    style={{ width: "100%", height: "100%" }}
                    src={
                      profile?.isShow?.startsWith("http")
                        ? profile.isShow
                        : `${process.env.REACT_APP_URI}/${encodeURI(decodeURI(profile?.isShow || ""))}`
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = require("../../assets/images/bg-profile.png");
                    }}
                  />
                </span>
                <span
                  className="cross"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setProfile((prev) => ({
                      ...prev,
                      uploadPic: "",
                      isShow: "",
                    }));
                  }}
                >
                  <Cancel
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? white?.main : dark.main,
                    })}
                  />
                </span>
              </div>
            )}
          </MDBox>
          {/* Category Banner Image section commented out
          <MDBox
            display="flex"
            alignItems="flex-start"
            flexDirection="column"
            lineHeight={1}
            gap={3}
            width={"75%"}
          >
            <MDTypography variant="h6">
              Category Banner Image{" "}
              <MDTypography variant="body1" component="span" fontSize={11}>
                &nbsp; ( image size - 178 × 178 px )
              </MDTypography>
            </MDTypography>
            <ImagePicker
              disabled={createUpdateLoading}
              name="bannerImage"
              multiple={true}
              images={profile?.bannerImage}
              setImages={(e) => {
                setProfile((prev) => ({
                  ...prev,
                  bannerImage: e,
                }));
              }}
            />
            {profile?.serverBannerImage && profile?.serverBannerImage?.length ? (
              <div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
                {profile?.serverBannerImage?.map((ele, i) => (
                  <span style={{ display: "flex", alignItems: "flex-start" }} key={i}>
                    <span
                      style={{
                        display: "inline-block",
                        width: "50px",
                        height: "50px",
                        margin: "0 0.5rem",
                      }}
                    >
                      <img
                        className="Image"
                        style={{ width: "100%", height: "100%" }}
                        src={`${process.env.REACT_APP_URI}/${ele?.url}`}
                      />
                    </span>
                    <span
                      className="cross"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        dispatch(
                          unlinkImage({
                            url: `/unLinks/${profile?.categoryId}/${admin}`,
                            data: { imageIndex: i + 1 },
                            notFormData: true,
                          })
                        ).then((data) => {
                          if (data?.payload?.success) {
                            const temp = [...profile?.serverBannerImage];
                            temp.splice(i, 1);
                            setProfile((prev) => ({
                              ...prev,
                              serverBannerImage: temp,
                            }));
                            dispatch(
                              handleAlert({
                                isOpen: true,
                                type: `${data.payload.success ? "success" : "error"}`,
                                msg: data.payload.message,
                              })
                            );
                          }
                        });
                      }}
                    >
                      <Cancel
                        sx={({ palette: { dark, white, info } }) => ({
                          color: darkMode ? white?.main : dark.main,
                        })}
                      />
                    </span>
                  </span>
                ))}
              </div>
            ) : null}
          </MDBox> */}

          <MDBox
            sx={{ width: "75%", justifyContent: "flex-end", textAlign: "center", display: "flex" }}
          >
            {" "}
            <MDButton color={"info"} verdant={"gradient"} type={"submit"}>
              {createUpdateLoading ? (
                <CircularProgress color="primary" size={20} />
              ) : isUpdates ? (
                `Update Sub Category`
              ) : (
                "Create Sub Category"
              )}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </>
  );
};

export default SubcategoryUpdate;

SubcategoryUpdate.propTypes = {
  viewData: PropTypes.any,
  isUpdates: PropTypes.bool,
  filter: PropTypes.bool,
  setIsOpenUpdate2: PropTypes.func,
  pagess: PropTypes.any,
  search: PropTypes.string,
};
